export default __webpack_public_path__ + "static/media/47_mobile.4435527e.jpg";